import { IFetchReparcelingByHashDTO } from 'modules/customer/domain/dtos';
import { IReparcelingsRepository } from 'modules/customer/domain/repositories';

export class FetchReparcelingByHashUseCase {
  constructor(private reparcelingsRepository: IReparcelingsRepository) {}

  public async execute({ hash }: IFetchReparcelingByHashDTO) {
    return this.reparcelingsRepository.findByHash(hash);
  }
}
